import { useEffect, useState } from "react";
import { getSiteContext, type SiteContext } from "../admin/api";

/**
 * Fetches the current user's site context once (which site they're locked to,
 * or the list of sites a company-wide user can switch among). Fails silent to
 * "company-wide, no sites" so a hiccup never blocks the dashboard.
 */
export function useSiteContext(): SiteContext | null {
  const [context, setContext] = useState<SiteContext | null>(null);

  useEffect(() => {
    let cancelled = false;
    void getSiteContext()
      .then((result) => {
        if (!cancelled) setContext(result);
      })
      .catch(() => {
        if (!cancelled) setContext({ scoped: false, site_id: null, site_name: null, sites: [] });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return context;
}
